import { SellerListBuilderPreviewInput } from '__generated__/graphql'
import { ListCriteria } from 'features/ListBuilder/domain/ListCriteria'
import { encode } from './encode'

/**
 * GraphQL input differs slightly from legacy REST payload shape.
 * This adapter keeps existing criteria encoding and normalizes the field names.
 */
export const toSellerListBuilderPreviewInput = (
  criteria: ListCriteria,
): SellerListBuilderPreviewInput => {
  const encoded = encode(criteria)

  return {
    limit: encoded.limit,
    newOnly: encoded.newOnly,
    filters: encoded.filters as SellerListBuilderPreviewInput['filters'],
    location: {
      city: toMutableArray(encoded.location.city),
      county: toMutableArray(encoded.location.county),
      neighborhood: toMutableArray(encoded.location.neightborhood),
      zip: toMutableArray(encoded.location.zip),
    },
  }
}

const toMutableArray = <T>(
  value: readonly T[] | null | undefined,
): T[] | null | undefined =>
  value ? [...value] : value
